import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
  OnChanges,
  ViewEncapsulation,
} from "@angular/core";
import { Message } from "src/app/models/message-model";
import { Subscription } from "rxjs";
import { ChatService } from "../../../chat.service";
import { StarRatingModalComponent } from "../star-rating-modal/star-rating-modal.component";
import { OwlOptions } from "ngx-owl-carousel-o";
import { RegistrationService } from "src/app/services/registration.service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-message",
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.css", "../../../styling.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MessageComponent implements OnInit, OnDestroy, OnChanges {
  subscription: Subscription;
  @Input() message: Message;
  // @Input() lastMsg:Message
  @Input() lastMsg: any = {
    sessionAttributes: {},
    showInput: true,
    sessionDetails: {},
    userInfo: {},
  };
  @Input() intentName: string;
  @Input() showBotIcon: any;
  sessionAttributes: any;
  typingIndicator: boolean = true;
  @Output() suggestionMsgEv = new EventEmitter<any>();
  @Output() triggerRatingModuleEV = new EventEmitter<any>();
  isLastResponseNBI: boolean;
  showStarRatingModule: boolean;
  chatbot_lang = localStorage.getItem("chatbot_lang") || "en";
  userInfo: any;
  dateOfBirth: string;
  constructor(
    private chatService: ChatService,
    private route: ActivatedRoute,
    private registrationService: RegistrationService
  ) {
    // this.subscription = this.chatService.typingIndicatorFn().subscribe(typing => {
    //   this.typingIndicator = typing
    // });
  }
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    items: 2,
    dots: false,
    navSpeed: 700,
    navText: ["<", ">"],
    responsive: {
      992: {
        items: 1.5,
      },
      768: {
        items: 1.5,
      },
      400: {
        items: 1.5,
      },
      0: {
        items: 1.5,
      },
    },
    nav: true,
  };
  phone = "";
  name = "";
  email = "";
  clientId = "";
  sessionId: any = new Date();
  ngOnInit() {
    setTimeout(() => {
      this.route.queryParams.subscribe((params) => {
        if (params.lang) {
          this.chatbot_lang = params.lang;
          localStorage.setItem("chatbot_lang", this.chatbot_lang);
        }
        // localStorage.getItem("chatbot_lang")
        // localStorage.setItem("chatbot_lang", this.chatbot_lang);
      });
    }, 1000);
    console.log("message22", this.message.content);

    if (localStorage.getItem("chatbot_lang") !== null) {
      this.chatbot_lang = localStorage.getItem("chatbot_lang");
      console.log(this.chatbot_lang, "lan");
    }
    if (
      this.message.hasOwnProperty("content") &&
      this.message.content == "Thank you for chatting with us. Goodbye."
    ) {
      this.triggerRatingModule();
    } else {
      this.showStarRatingModule = false;
    }

    // if(this.message.content == 'NBI'){
    //     this.isLastResponseNBI = true
    // } else {
    //     this. isLastResponseNBI = false
    // }

    // if (this.intentName =="scheduleDemoWW"){
    //   this.message.content = this.message.content +"\n"+`<a href='' onclick="Calendly.initPopupWidget({url: 'https://calendly.com/thinglogix-demos/testing-ww-chatbot'});return false;\">Schedule a call for Demo</a>`
    // }
    setTimeout(() => {
      console.log(this.lastMsg);
    }, 2000);

    //!
    if (
      this.lastMsg.hasOwnProperty("sessionState") &&
      this.lastMsg.sessionState.hasOwnProperty("sessionAttributes") &&
      this.lastMsg.sessionState.sessionAttributes.hasOwnProperty("userInfo")
    ) {
      this.userInfo = JSON.parse(
        this.lastMsg.sessionState.sessionAttributes.userInfo
      );
      this.lastMsg.userInfo = this.userInfo;
    }

    if (
      localStorage.getItem("phone") &&
      this.lastMsg.userInfo.phoneNumber == null &&
      this.lastMsg.sessionState.sessionAttributes.phoneNumber == null
    ) {
      this.sessionId = localStorage.getItem("sessionId");
      console.log("sessionId reg", this.sessionId);
      this.sessionId = this.sessionId.toString();
      this.phone = localStorage.getItem("phone");
      this.name = localStorage.getItem("name");
      this.email = localStorage.getItem("email");
      this.clientId = localStorage.getItem("clientId");
      this.dateOfBirth = localStorage.getItem("dateOfBirth");
    } else if (
      this.lastMsg.userInfo.hasOwnProperty("phoneNumber") &&
      this.lastMsg.userInfo.phoneNumber != null
    ) {
      //this.sessionId = (Math.floor(new Date().valueOf() * Math.random())).toString();
      localStorage.setItem("chatbot_lang", this.chatbot_lang);
      localStorage.setItem("phone", this.lastMsg.userInfo.phoneNumber);
      this.registrationService.registrationForm.phoneNumber = this.lastMsg.userInfo.phoneNumber
      localStorage.setItem("clientId", this.lastMsg.userInfo.clientId);
      localStorage.setItem("dateOfBirth", this.lastMsg.userInfo.dateOfBirth);
      // console.log("phone reg", this.phone)
      localStorage.setItem(
        "name",
        this.lastMsg.userInfo.firstName + " " + this.lastMsg.userInfo.lastName
      );
      localStorage.setItem("email", this.lastMsg.userInfo.email);
    }

    if (
      this.lastMsg.sessionState.intent.slots.hasOwnProperty("email") &&
      this.lastMsg.sessionState.intent.slots.email.value.originalValue != null
    ) {
      console.log("test", this.lastMsg);
      localStorage.setItem("chatbot_lang", this.chatbot_lang);
      localStorage.setItem(
        "phone",
        this.lastMsg.sessionState.intent.slots.phone.value.originalValue
      );
      console.log("phone reg", this.phone);
      localStorage.setItem(
        "name",
        this.lastMsg.sessionState.intent.slots.name.value.originalValue
      );
      localStorage.setItem(
        "email",
        this.lastMsg.sessionState.intent.slots.email.value.originalValue
      );
      console.log(
        "phone reg",
        this.lastMsg.sessionState.sessionAttributes.email
      );
    }

    //! to check if the first message is a valid phone number or not:
    if (
      (this.message.content == "user isnt registered" ||
        this.message.content == "El usuario no está registrado") &&
      !this.registrationService.registrationForm.firstName
    ) {
      this.registrationService.showRegForm();
    }
  }

  triggerRatingModule() {
    this.triggerRatingModuleEV.emit();
    // this.showStarRatingModule = false
    // let element: HTMLElement = document.getElementById("starRating") as HTMLElement
    // element.click()
  }

  ngOnChanges(changes) {
    console.log("changes", changes);
    // changes.prop contains the old and the new value...
  }
  sendMessage(msg, divId, slotToElicit,msg_text?:string) {
    console.log("msg_text==>",msg_text)
    this.typingIndicator = true;
    const suggestionMsgDetails = {
      msg,
      divId,
      slotToElicit,
      sessionAttributes: this.sessionAttributes,
      msg_text:msg_text
    };
    this.suggestionMsgEv.emit(suggestionMsgDetails);
  }
  sendMessage1(msg, divId, slotToElicit, name, text,msg_text?:string) {
    console.log("msg_text==>22",msg_text)
    this.typingIndicator = true;
    const suggestionMsgDetails = {
      msg,
      divId,
      slotToElicit,
      sessionAttributes: this.sessionAttributes,
      msg_text:msg_text
    };
    document.getElementById(name).style.background = "#182F7C";
    document.getElementById(text).style.color = "#ffffff";
    this.suggestionMsgEv.emit(suggestionMsgDetails);
  }
  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  // isArabic(message: any) : boolean{
  //   if (localStorage.getItem('chatbot_lang') !== null) {
  //     this.chatbot_lang = localStorage.getItem('chatbot_lang');
  //     this.arabic = this.chatbot_lang
  //   }
  //   return this.arabic.test(message)

  //  }



  isArabic(message): boolean {
    if (localStorage.getItem("chatbot_lang") !== null) {
      this.chatbot_lang = localStorage.getItem("chatbot_lang");
      // console.log(this.chatbot_lang,'lan')
      // this.arabic = this.chatbot_lang
    }
    if (this.chatbot_lang == "ar") {
      return true;
    } else if (this.chatbot_lang == "en") {
      return false;
    }
  }
}
